import Device from '../modules/utils/class/device';

import '../../scss/styles.scss';

if (!window.__DOMReady) {
  window.__DOMReady = new Promise((resolve) => {
    window.__resolveDOMReady = resolve;
  });
}

Device.init();

const { isMac, isSafari, isLowPower } = Device;

function entry () {
  window.scrollTo(0, 0);

  isLowPower.then((result) => {
    const videos = document.querySelectorAll('.site-video');

    if (videos.length) {
      [...videos].forEach((video) => {
        const placeholder = video.parentNode.querySelector('.site-video-placeholder');
        const fallback = video.parentNode.querySelector('.site-video-fallback');
        const mobile = video.parentNode.querySelector('.site-video-mobile');

        if (isMac && isSafari) {
          if (result) {
            if (placeholder) {
              video.remove();

              if (fallback) fallback.remove();
              if (mobile) mobile.remove();

              placeholder.classList.add('visible');

              /* Minor Fixes */

              const unique = document.querySelector('.block-02--background-video');

              if (unique) unique.classList.add('low-power-mode');
            }
          } else {
            if (fallback) {
              video.remove();

              if (placeholder) placeholder.remove();
              if (mobile) mobile.remove();

              fallback.classList.add('visible');
            }
          }
        }

        if (video.classList.contains('xtrnd-video') && window.innerWidth < 1200) {
          if (mobile) {
            video.remove();

            if (placeholder) placeholder.remove();
            if (fallback) fallback.remove();

            mobile.classList.add('visible');
          }

          if (!mobile && fallback) {
            video.remove();

            if (placeholder) placeholder.remove();
            if (mobile) mobile.remove();

            fallback.classList.add('visible');
          }
        }

        if (window.innerWidth < 768) {
          if (mobile) {
            video.remove();

            if (placeholder) placeholder.remove();
            if (fallback) fallback.remove();

            mobile.classList.add('visible');
          }

          if (!mobile && fallback) {
            video.remove();

            if (placeholder) placeholder.remove();
            if (mobile) mobile.remove();

            fallback.classList.add('visible');
          }
        }
      });
    }

    setTimeout(() => {
      if (typeof window.__resolveDOMReady === 'function') {
        window.__resolveDOMReady();

        delete window.__resolveDOMReady;
      }
    });
  });
}

document.addEventListener('DOMContentLoaded', entry);
